"use client";

import { c as _c } from "react/compiler-runtime";
import type { CreateWaveDatesConfig } from "@/types/waves.types";
import CreateWaveDatesApproveStart from "./CreateWaveDatesApproveStart";
import CreateWaveDatesApproveEnd from "./CreateWaveDatesApproveEnd";
import type { CREATE_WAVE_VALIDATION_ERROR } from "@/helpers/waves/create-wave.validation";
interface CreateWaveDatesApproveProps {
  readonly dates: CreateWaveDatesConfig;
  readonly errors: CREATE_WAVE_VALIDATION_ERROR[];
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
}
export default function CreateWaveDatesApprove(t0) {
  const $ = _c(10);
  const {
    dates,
    errors,
    setDates
  } = t0;
  let t1;
  if ($[0] !== dates || $[1] !== setDates) {
    t1 = <CreateWaveDatesApproveStart dates={dates} setDates={setDates} />;
    $[0] = dates;
    $[1] = setDates;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== dates || $[4] !== errors || $[5] !== setDates) {
    t2 = <CreateWaveDatesApproveEnd dates={dates} errors={errors} setDates={setDates} />;
    $[3] = dates;
    $[4] = errors;
    $[5] = setDates;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div className="tw-space-y-4">{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}